export { default } from './file-icon-preview';
